__turbopack_context__.v({
  "container": "DealsPageNew-module__KigCIG__container",
  "pageWrapper": "DealsPageNew-module__KigCIG__pageWrapper",
});
